import * as yup from "yup";

export default yup.object().shape({
  userId: yup.string().required("이메일 주소를 확인해주세요."),
  userPw: yup.string().required("비밀번호를 확인해주세요."),
});
